import { u as t } from "../../jsxRuntime.module-Bzuv3cXw.js";
import { c as n, S as i, C as s } from "../../useActions-BIIcXXS6.js";
import { d as c, u as f, S as C } from "../../baseConfig-CTN0CcW-.js";
const l = {
  ...c,
  persistentSearchCache: !1,
  preservePageScroll: !1
};
function u(e) {
  return {
    pageType: "category",
    ...l,
    ...e
  };
}
function m({ config: e, store: r, children: o }) {
  const a = r ?? n();
  return f(), /* @__PURE__ */ t(s, { value: u(e), children: /* @__PURE__ */ t(i, { value: a, children: [
    /* @__PURE__ */ t(C, {}),
    o
  ] }) });
}
export {
  m as CategoryPageProvider
};
